import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { toast } from 'react-toastify'
import { toastConfig } from '../../helpers/toastConfig'
import RootStore from '../../store/RootStore'
import IssueItem from '../Issue/IssueItem'
import UserSelect from '../AppHeader/UserSelect'

type Props = {}

const EditIssue = observer((props: Props) => {
  const open = RootStore.modalsUi.editIssue
  const issue = RootStore.modalsUi.issue

  const hundleClose = () => {
    RootStore.modalsUi.hundleEditIssue(false)
  }

  if (!issue) return <></>

  const hundleChange = async () => {
    try {
      await RootStore.userAction.acceptIssue(issue.id)
      toast.success(`Заявка принята`, {
        ...toastConfig,
      })
      hundleClose()
    } catch (error: any) {
      const data = error.response?.data

      toast.error(data?.message ?? 'Произошла ошибка', {
        ...toastConfig,
      })

      if (data.property) {
      }
    }
  }
  const hundleDelete = async () => {
    try {
      await RootStore.userAction.deleteIssue(issue.id)
      toast.success(`Заявка удалена`, {
        ...toastConfig,
      })
      hundleClose()
    } catch (error: any) {
      const data = error.response?.data

      toast.error(data?.message ?? 'Произошла ошибка', {
        ...toastConfig,
      })

      if (data.property) {
      }
    }
  }

  return (
    <Dialog open={open} onClose={hundleClose}>
      <DialogTitle>Принять заявку?</DialogTitle>
      <div>
        <DialogContent>
          <UserSelect filters={{ role: issue.role?.value ?? '' }} />
          {issue ? <IssueItem issue={issue} noAction /> : null}
        </DialogContent>
      </div>

      <DialogActions
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Button color="error" onClick={hundleDelete}>
          Отменить
        </Button>

        <div>
          <Button onClick={hundleChange}>Принять</Button>
          <Button onClick={hundleClose}>Отмена</Button>
        </div>
      </DialogActions>
    </Dialog>
  )
})

export default EditIssue
